/*
 *
 * StructureTextInput
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 03-Mar-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import './StructureTextInput.scss'
import PortalTextInput from '@nexidigital/portaltextinput'

const StructureTextInput = ({ formik, id, label, type = 'text', maxLength = 255 }) => (
  <PortalTextInput
    placeholderBlank
    label={label}
    id={id}
    type={type}
    maxLength={maxLength}
    error={formik.errors[id] && formik.touched[id]}
    errorText={formik.errors[id]}
    {...formik.getFieldProps(id)}
  />
)

StructureTextInput.propTypes = {
  formik: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  maxLength: PropTypes.number
}

StructureTextInput.defaultProps = {
  type: 'text',
  maxLength: 255
}

export default StructureTextInput
